import React from 'react';

import { EInvoicingPortal } from '../../pages/EInvoicingPortal';
import { InitiateNewRegistration } from '../../pages/InitiateNewRegistration';
import { ManageExistingSolutions } from '../../pages/ManageExistingSolutions';
import { CreateInvoice } from '../../pages/SmePortal/pages/CreateInvoice';
import { InvoiceList } from '../../pages/SmePortal/pages/InvoiceList';
import { ViewInvoice } from '../../pages/SmePortal/pages/ViewInvoice';

import { InnerDashboard as SmeInnerDashboard } from '../../pages/SmePortal/pages/InnerDashboard';

import { InvoiceView } from '../../pages/InvoiceView';
import { ServiceProvider } from '../../pages/ServiceProvider';
import { ServiceProviderTable } from '../../pages/ServiceProvider/ServiceProviderTable';
import { AdditionalFunctionalities } from '../../pages/AdditionalFunctionalities';
import {
  FailuresList,
  ReportFailure,
  ResolveFailure,
} from '../../pages/FailureNotification';
import { ManageNotifications } from '../../pages/ManageNotifications';
import { SpecialBillingList } from '../../pages/SpecialBilling';
import AddNewBillingAgreement from '../../pages/SpecialBilling/pages/AddNewBillingAgreement/AddNewBillingAgreement';
import AmendBillingAgreement from '../../pages/SpecialBilling/pages/AmendBillingAgreement/AmendBillingAgreement';
import { ActivatePointOfContact } from '../../pages/ActivatePointOfContact';
import ReviewBillingAgreement from '../../pages/SpecialBilling/pages/ReviewBillingAgreement/ReviewBillingAgreement';

export const routeConfig = {
  showSolutionRegistration: true,
  showDashboard: true,
  showTaxReturn: true,
  showInvoiceView: true,
  showServiceProvider: false,
  showSme: true,
  smeTypes: ['standard', 'simplified'],
};

export const ROUTES = ({ baseRoute, TAX_COUNTRY, config }) => [
  {
    path: `${baseRoute}`,
    element: null,
    nestedRoutes: [
      {
        path: '',
        element: <EInvoicingPortal />,
        nestedRoutes: null,
      },
      {
        path: 'activate-point-of-contact',
        element: <ActivatePointOfContact />,
        nestedRoutes: null,
      },
      {
        path: 'manage-notifications',
        element: <ManageNotifications />,
        nestedRoutes: null,
      },
      config.showSolutionRegistration && {
        path: 'my-devices',
        element: null,
        nestedRoutes: [
          {
            path: '',
            element: <ManageExistingSolutions />,
            nestedRoutes: null,
          },
          {
            path: 'initiate-new-registration',
            element: <InitiateNewRegistration />,
            nestedRoutes: null,
          },
        ],
      },
      config.showInvoiceView && {
        path: 'invoice-view',
        element: <InvoiceView />,
        nestedRoutes: null,
      },
      // config.showDashboard && {
      //   path: 'dashboard',
      //   element: <Dashboard />,
      //   nestedRoutes: null,
      // },
      {
        path: 'additional-functionalities',
        element: null,
        nestedRoutes: [
          {
            path: '',
            element: <AdditionalFunctionalities />,
            nestedRoutes: null,
          },
          {
            path: 'failure-notification',
            element: null,
            nestedRoutes: [
              {
                path: '',
                element: <FailuresList />,
                nestedRoutes: null,
              },
              {
                path: ':id',
                element: <ResolveFailure />,
                nestedRoutes: null,
              },
              {
                path: 'report',
                element: <ReportFailure />,
                nestedRoutes: null,
              },
              {
                path: 'resolve/:id',
                element: <ResolveFailure />,
                nestedRoutes: null,
              },
            ],
          },
          {
            path: 'special-billing',
            element: null,
            nestedRoutes: [
              {
                path: '',
                element: <SpecialBillingList />,
                nestedRoutes: null,
              },
              {
                path: 'add',
                element: <AddNewBillingAgreement />,
                nestedRoutes: null,
              },
              {
                path: 'edit/:id',
                element: <AddNewBillingAgreement />,
                nestedRoutes: null,
              },
              {
                path: 'amend/:id',
                element: <AmendBillingAgreement />,
                nestedRoutes: null,
              },
              {
                path: 'review/:id',
                element: <ReviewBillingAgreement />,
                nestedRoutes: null,
              },
            ],
          },
          config.showSme && {
            path: 'sme',
            element: null,
            nestedRoutes: [
              {
                path: '',
                element: <InvoiceList />,
                nestedRoutes: null,
              },
              {
                path: 'view-invoice/:id/:type',
                element: <ViewInvoice />,
                nestedRoutes: null,
              },
              {
                path: 'create',
                element: null,
                nestedRoutes: [
                  {
                    path: '',
                    element: <SmeInnerDashboard />,
                    nestedRoutes: null,
                  },
                  {
                    path: 'invoice',
                    element: (
                      <CreateInvoice taxCountry={TAX_COUNTRY} type="invoice" />
                    ),
                    nestedRoutes: null,
                  },
                  {
                    path: 'credit',
                    element: (
                      <CreateInvoice taxCountry={TAX_COUNTRY} type="credit" />
                    ),
                    nestedRoutes: null,
                  },
                  {
                    path: 'debit',
                    element: (
                      <CreateInvoice taxCountry={TAX_COUNTRY} type="debit" />
                    ),
                    nestedRoutes: null,
                  },
                ],
              },
              {
                path: 'edit-invoice',
                element: null,
                nestedRoutes: [
                  {
                    path: ':id',
                    element: (
                      <CreateInvoice taxCountry={TAX_COUNTRY} type="invoice" />
                    ),
                    nestedRoutes: null,
                  },
                ],
              },
              {
                path: 'view-list',
                element: null,
                nestedRoutes: [
                  {
                    path: '',
                    element: <InvoiceList />,
                    nestedRoutes: null,
                  },
                  {
                    path: 'view-invoice/:id/:type',
                    element: <ViewInvoice />,
                    nestedRoutes: null,
                  },
                ],
              },
            ],
          },
        ],
      },

      config.showServiceProvider && {
        path: 'service-provider',
        element: null,
        nestedRoutes: [
          { path: '', element: <ServiceProvider />, nestedRoutes: null },
          {
            path: 'dashboard',
            element: <ServiceProviderTable />,
            nestedRoutes: null,
          },
        ],
      },
    ].filter(Boolean),
  },
];
